
import customBtn from '@/components/common/btn/custom-btn.vue'
import { useStore } from 'vuex'
import sensors from '@/utils/sensors'
import { defineComponent, reactive, toRefs, computed } from 'vue'
export default defineComponent({
    components: { customBtn },
    name: 'enroll-success-popup',
    emits: ['toggleEnrollSuccessPopup'],
    props: {
        isShowPopup: {
            type: Boolean
        },
        popupType: {
            type: Number
        }
    },
    setup(props: any, { emit }) {
        const store = useStore()
        const data = reactive({
            activityInfo: computed(() => store.state.activityInfo),
            browserEnv: computed(() => store.state.browserEnv),
            couponEnrollHint: '领取成功，稍后金牌顾问将电话为您讲解优惠',
            driveEnrollHint: '预约成功，具体使用方法可在太平洋汽车app-我的-优惠券中进行查看和使用！',
            downloadLink: 'https://www1.pcauto.com.cn/zt/gz202012/openinstall/wap/wap-openinstall_channel.html?channelCode=NB006',
        })
        const methods = {
            togglePopup(value: boolean) {
                emit('toggleEnrollSuccessPopup', value);
            },
            confirmButtonClick() {
                if (props.popupType === 1 && data.browserEnv === 3) {
                    window.location.href = data.downloadLink;
                }
                methods.togglePopup(false);
            }
        }
        return {
            ...toRefs(data),
            ...methods
        }
    },
})
